<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Árukészlet</span>
    </div>
    <storage-stock-list/>

    <template v-if="$route.meta.showViewStorageStockDialog">
      <view-dialog
              :productId="$route.params.productId"
      />
    </template>
  </el-card>
</template>

<script>
import StorageStockList from '../../components/reports/storageStock/List';
import ViewDialog from '../../components/reports/storageStock/View';

export default {
  components: {
    StorageStockList,
    ViewDialog,
  },
};
</script>
